import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
// Form
import InsuredFormSectionPage from './pages/Form/Insured';
import LocationsFormSectionPage from './pages/Form/Locations';
import CoverageAndClassesFormSectionPage from './pages/Form/CoverageAndClasses';
import CurrentCoverageFormSectionPage from './pages/Form/CurrentCoverage';
import OwnersOfficersFormSectionPage from './pages/Form/OwnersOfficers';
import AdditionalQuestionsFormSectionPage from './pages/Form/AdditionalQuestions';
import PolicyOwnershipAndFraudStatement from './pages/Form/PolicyOwnershipAndFraudStatement';
import Attachments from './pages/Form/Attachments';
// Home
import HomePage from './pages/HomePage';
// 404
import Page404 from './pages/Page404';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/form',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/form/insured" />, index: true },
        { path: 'insured', element: <InsuredFormSectionPage /> },
        { path: 'locations', element: <LocationsFormSectionPage /> },
        { path: 'current-coverage', element: <CurrentCoverageFormSectionPage /> },
        { path: 'coverage-and-classes', element: <CoverageAndClassesFormSectionPage /> },
        { path: 'owners-officers', element: <OwnersOfficersFormSectionPage /> },
        { path: 'additional-questions', element: <AdditionalQuestionsFormSectionPage /> },
        { path: 'policy-ownership-and-fraud-statement', element: <PolicyOwnershipAndFraudStatement /> },
        { path: 'attachments', element: <Attachments /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <HomePage />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
